import React from 'react';
import { getArticleCategory, ArticleLocalizedEntity } from 'src/modules/articles';
import {
  LayoutCardList,
  LayoutCardSize,
  LayoutCardListHeading,
  LayoutCardType,
} from 'src/modules/layout';
import styles from './ArticleListingOverview.module.scss';

interface ArticleListingOverviewProps {
  headingTitle?: string;
  relatedOverview?: boolean;
  size?: LayoutCardSize;
  articles: Array<ArticleLocalizedEntity>;
  link: ArticleLinkPrefix;
  oneRow?: boolean;
  truncateTitle?: boolean;
}

export enum ArticleLinkPrefix {
  article = 'magazine',
  reference = 'professionals/projects',
}

export const ArticleListingOverview: React.FunctionComponent<ArticleListingOverviewProps> = (
  props
) => {
  const {
    relatedOverview,
    articles,
    headingTitle = 'page/magazine/details/related_articles',
    link,
    oneRow = true,
    size = LayoutCardSize.Big,
    truncateTitle = false,
  } = props;

  const articleCards = oneRow ? articles?.slice(0, 3) : articles;

  return !!articleCards?.length ? (
    <div className={styles.container}>
      {relatedOverview && (
        <div className={styles.heading}>
          <LayoutCardListHeading title={headingTitle} />
        </div>
      )}

      <LayoutCardList
        size={size}
        wrap={!oneRow}
        type={LayoutCardType.Overview}
        truncateTitle={truncateTitle}
        items={articleCards.map((article) => ({
          title: article?.hero?.title,
          image: article?.hero?.image,
          caption: getArticleCategory(article),
          link,
          slug: article?.slug,
        }))}
      />
    </div>
  ) : null;
};

export default ArticleListingOverview;
